class CartCouponForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
    this.storagePrefix = 'velixco-discount-attempt-';
  }

  connectedCallback() {
    this.form = this.querySelector('.cart-coupon__form');
    this.form?.removeEventListener('submit', this.onSubmit);
    this.form?.addEventListener('submit', this.onSubmit);
    this.maybeAutoApply();
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  getAppliedTitles() {
    const raw = this.dataset.appliedDiscounts || '';
    return raw
      .split(',')
      .map((title) => title.trim())
      .filter(Boolean);
  }

  isCodeApplied(code) {
    const normalized = code.trim().toLowerCase();
    return this.getAppliedTitles().some((title) => title === normalized);
  }

  redirectToDiscount(code) {
    const root = this.dataset.root || '/';
    const redirect = `${window.location.pathname}${window.location.search}`;
    const applyUrl = `${root}discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(redirect)}`;

    const button = this.querySelector('.cart-coupon__apply');
    if (button) {
      button.setAttribute('aria-disabled', 'true');
      button.classList.add('loading');
    }

    window.location.assign(applyUrl);
  }

  getAutoApplyCodes() {
    const codes = [];
    const primary = (this.dataset.autoApplyCode || '').trim();
    const secondary = (this.dataset.autoApplyCodeSecondary || '').trim();

    if (primary) codes.push(primary);
    if (secondary && secondary.toLowerCase() !== primary.toLowerCase()) codes.push(secondary);

    return codes;
  }

  maybeAutoApply() {
    if (this.dataset.autoApplyEnabled !== 'true') return;

    for (const code of this.getAutoApplyCodes()) {
      if (this.isCodeApplied(code)) continue;

      const attemptKey = `${this.storagePrefix}${code.toLowerCase()}`;
      if (sessionStorage.getItem(attemptKey)) continue;

      sessionStorage.setItem(attemptKey, '1');
      this.redirectToDiscount(code);
      return;
    }
  }

  onSubmit(event) {
    event.preventDefault();

    const input = this.querySelector('[name="coupon"]');
    const code = input?.value.trim();

    if (!code) {
      input?.focus();
      return;
    }

    this.redirectToDiscount(code);
  }
}

if (!customElements.get('cart-coupon-form')) {
  customElements.define('cart-coupon-form', CartCouponForm);
}
